var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 88,
    viewBox: "0 0 120 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.59 45.4774C102.59 55.1261 99.363 64.0063 94.0127 71.1788C91.0403 75.0212 87.4734 78.4367 83.397 81.0837C76.7728 85.4384 68.8747 88 60.3821 88C37.0276 88 18.1741 68.9588 18.1741 45.5628C18.1741 22.0814 37.1125 3.12549 60.3821 3.12549C68.8747 3.12549 76.7728 5.68709 83.397 9.95644C87.4734 12.6034 91.0403 16.0189 94.0127 19.8613C99.448 26.9484 102.59 35.8287 102.59 45.4774Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7053 11.9965C26.8204 11.6321 27.4306 10.4278 27.0682 9.30663C26.7057 8.18545 25.5079 7.57197 24.3928 7.93638C23.2776 8.30078 22.6675 9.50508 23.0299 10.6263C23.3924 11.7474 24.5902 12.3609 25.7053 11.9965Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3399 5.03146C31.0982 4.78367 31.5131 3.96475 31.2666 3.20235C31.0201 2.43996 30.2056 2.02278 29.4473 2.27057C28.6891 2.51836 28.2741 3.33728 28.5206 4.09968C28.7671 4.86208 29.5816 5.27925 30.3399 5.03146Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.135 17.4224C103.451 16.2135 103.542 14.1611 102.34 12.8383C101.138 11.5155 99.0965 11.4231 97.7807 12.6319C96.465 13.8408 96.3731 15.8932 97.5755 17.216C98.7779 18.5389 100.819 18.6313 102.135 17.4224Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.436 2.93866C102.99 2.42967 103.029 1.56552 102.522 1.00854C102.016 0.451551 101.157 0.412648 100.603 0.921644C100.049 1.43064 100.01 2.29479 100.516 2.85177C101.023 3.40876 101.882 3.44766 102.436 2.93866Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9384 83.1328H106.412",
    stroke: "#EBF0F6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.643 57.2446C85.8522 64.1863 80.2032 70.0763 73.299 70.2867H69.9515L60.7458 70.497C46.9373 70.7074 35.4301 59.7689 35.0117 45.8853C34.5933 32.0018 45.6819 20.4322 59.4905 20.0115C73.299 19.5908 84.8061 30.7397 85.2245 44.6232L85.4338 49.8821L85.643 57.2446Z",
    fill: "url(#paint0_linear_2877_73666)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9199 56.6141C83.1291 63.5559 77.4802 69.4458 70.5759 69.6562H67.2284L51.9553 54.3002L64.927 39.1545L69.739 36.4199L82.7107 49.462L82.9199 56.6141Z",
    fill: "url(#paint1_linear_2877_73666)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5614 45.4647L69.9551 41.0472C71.2104 39.785 71.2104 37.8918 69.9551 36.6297C68.6997 35.3676 66.8168 35.3676 65.5614 36.6297L61.1678 41.0472L56.7742 36.6297C55.5189 35.3676 53.6359 35.3676 52.3806 36.6297C51.1253 37.8918 51.1253 39.785 52.3806 41.0472L56.7742 45.4647L52.3806 49.8821C51.1253 51.1443 51.1253 53.0375 52.3806 54.2996C53.0082 54.9307 53.8451 55.141 54.682 55.141C55.5189 55.141 56.3558 54.9307 56.9834 54.2996L61.377 49.8821L65.7707 54.2996C67.026 55.5618 68.909 55.5618 70.1643 54.2996C70.7919 53.6686 71.0012 52.8271 71.0012 51.9857C71.0012 51.1443 70.7919 50.3029 70.1643 49.6718L65.5614 45.4647Z",
    fill: "url(#paint2_linear_2877_73666)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2761 36.2554C10.2761 36.2554 1.86845 38.39 4.41622 40.0978C6.96399 41.7201 12.9937 44.5379 18.6837 42.6594C24.3738 40.7809 18.6837 38.1339 18.7687 38.1339C18.8536 38.1339 10.2761 36.2554 10.2761 36.2554Z",
    fill: "#CED7E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.5724C3.05732 36.5116 12.4841 34.9747 18.5138 31.0469C23.2696 36.9386 25.0531 38.4755 26.7516 38.6463C24.1189 41.2933 15.3716 45.5626 10.4459 40.0125C4.67091 43.6841 0 35.5724 0 35.5724Z",
    fill: "#DFE7F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3333 65.1164C96.5604 65.2872 105.308 61.3594 110.064 56.0654C116.178 60.5909 118.216 61.6156 120 61.3594C118.047 64.6041 112.102 71.6912 103.694 72.2035C97.5795 68.6173 93.3333 65.1164 93.3333 65.1164Z",
    fill: "#DFE7F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4628 58.9687C43.5885 58.9687 44.501 58.0512 44.501 56.9194C44.501 55.7876 43.5885 54.8701 42.4628 54.8701C41.3371 54.8701 40.4246 55.7876 40.4246 56.9194C40.4246 58.0512 41.3371 58.9687 42.4628 58.9687Z",
    fill: "url(#paint3_linear_2877_73666)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2877_73666",
    x1: 35.1115,
    y1: 45.2172,
    x2: 85.6484,
    y2: 45.2172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2877_73666",
    x1: 60.181,
    y1: 44.6617,
    x2: 72.5757,
    y2: 56.9894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01F79",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2877_73666",
    x1: 69.378,
    y1: 53.9443,
    x2: 53.4061,
    y2: 37.9327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#FFC9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2877_73666",
    x1: 40.4322,
    y1: 56.8899,
    x2: 44.5365,
    y2: 56.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossicon);
export default __webpack_public_path__ + "static/media/crossicon.486535b7979aba3d89de2ade848a09b9.svg";
export { ForwardRef as ReactComponent };